import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-refund-item-row',
    templateUrl: './refund-item-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class RefundItemRowComponent extends BaseRow {
}
